module.exports = __webpack_public_path__ + "fb7c43390f67161dc8b053d2db3d5464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile/Kudo.jpg
// module id = 99
// module chunks = 0